@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.header {
  @include blur;
  background: var(--light-40);
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.04), 1px 1px 0px 0px rgba(255, 255, 255, 0.9) inset;
  padding: 31px 44px;
  position: sticky;
  top: 0;
  z-index: 3;
  transition: padding 250ms ease;
  display: flex;

  @include for-phone-only {
    display: none;
  }
}

.headerInner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .headerLeft {
    display: flex;
    gap: 14px;
    align-items: center;
  }

  .headerRight {
    display: flex;
    gap: 10px;
    align-items: center;
  }
}

.extra {
  display: flex;
  align-items: center;
  gap: 6px;

  .infoIcon {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
